/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  PerpetualMarket,
  PerpetualMarketInterface
} from '../PerpetualMarket'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_perpetualMarketCoreAddress',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_quoteAsset',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_underlyingAsset',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_feeRecepient',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_vaultNFT',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'issued',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Deposited',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'DepositedToVault',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'hedger',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'isBuyingUnderlying',
        type: 'bool'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdcAmount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'underlyingAmount',
        type: 'uint256'
      }
    ],
    name: 'Hedged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'liquidator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reward',
        type: 'uint256'
      }
    ],
    name: 'Liquidated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'subVaultIndex',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'productId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeAmount',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingFeePerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'deltaUsdcPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'metadata',
        type: 'bytes'
      }
    ],
    name: 'PositionUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'feeRecepient',
        type: 'address'
      }
    ],
    name: 'SetFeeRecepient',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'burned',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'trader',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'WithdrawnFromVault',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_marginToAdd',
        type: 'int256'
      }
    ],
    name: 'addMargin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: '_withRebalance',
        type: 'bool'
      }
    ],
    name: 'execHedge',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amountUsdc',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amountUnderlying',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'feeRecepient',
    outputs: [
      {
        internalType: 'contract IFeePool',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_deltaLiquidityAmount',
        type: 'int256'
      }
    ],
    name: 'getLPTokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'int128[2]',
        name: '_tradeAmounts',
        type: 'int128[2]'
      }
    ],
    name: 'getMinCollateralToAddPosition',
    outputs: [
      {
        internalType: 'int256',
        name: 'minCollateral',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getPositionValueAndMinCollateral',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getTokenAmountForHedging',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int256[2]',
        name: '_tradeAmounts',
        type: 'int256[2]'
      }
    ],
    name: 'getTradePrice',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'tradePrice',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'indexPrice',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'fundingRate',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'tradeFee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'protocolFee',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'fundingFee',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'totalValue',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalFee',
            type: 'uint256'
          }
        ],
        internalType: 'struct IPerpetualMarket.TradeInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getTraderVault',
    outputs: [
      {
        components: [
          {
            internalType: 'int128',
            name: 'positionUsdc',
            type: 'int128'
          },
          {
            components: [
              {
                internalType: 'int128[2]',
                name: 'positionPerpetuals',
                type: 'int128[2]'
              },
              {
                internalType: 'uint128[2]',
                name: 'entryPrices',
                type: 'uint128[2]'
              },
              {
                internalType: 'int256[2]',
                name: 'entryFundingFee',
                type: 'int256[2]'
              }
            ],
            internalType: 'struct TraderVaultLib.SubVault[]',
            name: 'subVaults',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct TraderVaultLib.TraderVault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getVaultStatus',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minCollateral',
            type: 'int256'
          },
          {
            internalType: 'int256[2][]',
            name: 'positionValues',
            type: 'int256[2][]'
          },
          {
            internalType: 'int256[2][]',
            name: 'fundingPaid',
            type: 'int256[2][]'
          },
          {
            components: [
              {
                internalType: 'int128',
                name: 'positionUsdc',
                type: 'int128'
              },
              {
                components: [
                  {
                    internalType: 'int128[2]',
                    name: 'positionPerpetuals',
                    type: 'int128[2]'
                  },
                  {
                    internalType: 'uint128[2]',
                    name: 'entryPrices',
                    type: 'uint128[2]'
                  },
                  {
                    internalType: 'int256[2]',
                    name: 'entryFundingFee',
                    type: 'int256[2]'
                  }
                ],
                internalType: 'struct TraderVaultLib.SubVault[]',
                name: 'subVaults',
                type: 'tuple[]'
              }
            ],
            internalType: 'struct TraderVaultLib.TraderVault',
            name: 'rawVaultData',
            type: 'tuple'
          }
        ],
        internalType: 'struct IPerpetualMarket.VaultStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'hedger',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_initialFundingRate',
        type: 'int256'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'liquidateByPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'maxPositionsInVault',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'quoteAsset',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_feeRecepient',
        type: 'address'
      }
    ],
    name: 'setFeeRecepient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_hedger',
        type: 'address'
      }
    ],
    name: 'setHedger',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_maxFutureAmount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maxSquaredAmount',
        type: 'uint256'
      }
    ],
    name: 'setMaxAmount',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'productId',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'subVaultIndex',
                type: 'uint256'
              },
              {
                internalType: 'int128',
                name: 'tradeAmount',
                type: 'int128'
              },
              {
                internalType: 'uint256',
                name: 'limitPrice',
                type: 'uint256'
              },
              {
                internalType: 'bytes',
                name: 'metadata',
                type: 'bytes'
              }
            ],
            internalType: 'struct IPerpetualMarket.TradeParams[]',
            name: 'trades',
            type: 'tuple[]'
          },
          {
            internalType: 'int256',
            name: 'marginAmount',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct IPerpetualMarket.MultiTradeParams',
        name: '_tradeParams',
        type: 'tuple'
      }
    ],
    name: 'trade',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'underlyingAsset',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_withdrawnAmount',
        type: 'uint128'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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__$d529c113b49f05715913138dde996bfccf$__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__$d529c113b49f05715913138dde996bfccf$__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__$d529c113b49f05715913138dde996bfccf$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$d529c113b49f05715913138dde996bfccf$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'

type PerpetualMarketConstructorParams =
  | [linkLibraryAddresses: PerpetualMarketLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: PerpetualMarketConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  )
}

export class PerpetualMarket__factory extends ContractFactory {
  constructor(...args: PerpetualMarketConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      const [linkLibraryAddresses, signer] = args
      super(
        _abi,
        PerpetualMarket__factory.linkBytecode(linkLibraryAddresses),
        signer
      )
    }
  }

  static linkBytecode(
    linkLibraryAddresses: PerpetualMarketLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$d529c113b49f05715913138dde996bfccf\\$__', 'g'),
      linkLibraryAddresses['src/lib/TraderVaultLib.sol:TraderVaultLib']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    _perpetualMarketCoreAddress: string,
    _quoteAsset: string,
    _underlyingAsset: string,
    _feeRecepient: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PerpetualMarket> {
    return super.deploy(
      _perpetualMarketCoreAddress,
      _quoteAsset,
      _underlyingAsset,
      _feeRecepient,
      _vaultNFT,
      overrides || {}
    ) as Promise<PerpetualMarket>
  }
  getDeployTransaction(
    _perpetualMarketCoreAddress: string,
    _quoteAsset: string,
    _underlyingAsset: string,
    _feeRecepient: string,
    _vaultNFT: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _perpetualMarketCoreAddress,
      _quoteAsset,
      _underlyingAsset,
      _feeRecepient,
      _vaultNFT,
      overrides || {}
    )
  }
  attach(address: string): PerpetualMarket {
    return super.attach(address) as PerpetualMarket
  }
  connect(signer: Signer): PerpetualMarket__factory {
    return super.connect(signer) as PerpetualMarket__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PerpetualMarketInterface {
    return new utils.Interface(_abi) as PerpetualMarketInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpetualMarket {
    return new Contract(address, _abi, signerOrProvider) as PerpetualMarket
  }
}

export interface PerpetualMarketLibraryAddresses {
  ['src/lib/TraderVaultLib.sol:TraderVaultLib']: string
}
